import React from 'react';
import { AbsoluteFill } from 'remotion';
import { ThemeSystemConfig } from '../../clipCreator/remotion/Components/Theme/Theme';

// Debug logging control
const DEBUG_OVERLAY_LAYER = false;
import { AspectRatio } from '../AspectRatio';
import { TimelineDefaults } from '../TimelineDefaults';
import { LayerContainer } from './types';
import { OverlayItem, OverlayItemImpl } from '../types/overlay';

export class OverlayLayerContainer implements LayerContainer {
    items: OverlayItem[];

    constructor(items: OverlayItem[] = []) {
        // Type safety validation: Ensure only OverlayItem types are added
        items.forEach(item => {
            // Check for properties that indicate this is a TextOverlayItem
            if ('text' in item && typeof (item as any).text === 'string') {
                throw new Error(
                    `TextOverlayItem detected in OverlayLayerContainer. ` +
                    `Text overlays must be added to TextOverlayLayerContainer using timeline.addTextOverlay(). ` +
                    `Item ID: ${item.id}, Text: "${(item as any).text.substring(0, 50)}..."`
                );
            }
        });
        
        this.items = items;
    }

    render(fps: number, theme: ThemeSystemConfig, aspectRatio: AspectRatio, defaults: TimelineDefaults, videoConfig?: { width: number; height: number }): React.ReactNode {
        // Import useCurrentFrame from remotion
        const { useCurrentFrame } = require('remotion');
        const currentGlobalFrame = useCurrentFrame();
        const currentGlobalTime = currentGlobalFrame / fps;
        
        if (DEBUG_OVERLAY_LAYER) console.log('[OVERLAY LAYER CRITICAL] Rendering at global time:', currentGlobalTime.toFixed(2), 'with', this.items.length, 'items');
        this.items.forEach(item => {
            const itemStartTime = item.startAt;
            const entranceDuration = (item as any).entranceAnimation?.timing?.duration || 0;
            const sequenceStartTime = itemStartTime - entranceDuration;
            const itemEndTime = itemStartTime + (item.duration || 0);
            
            const shouldBeActive = currentGlobalTime >= sequenceStartTime && currentGlobalTime <= itemEndTime;
            
            if (DEBUG_OVERLAY_LAYER) console.log('[OVERLAY LAYER CRITICAL] Item:', item.id, {
                globalTime: currentGlobalTime.toFixed(2),
                sequenceStartTime: sequenceStartTime.toFixed(2),
                itemVisibleTime: itemStartTime.toFixed(2),
                itemEndTime: itemEndTime.toFixed(2),
                shouldBeActive,
                'STATUS': shouldBeActive ? '✅ ACTIVE' : '❌ INACTIVE'
            });
        });
        
        return (
            <AbsoluteFill>
                {this.items.map(item => (
                    <React.Fragment key={item.id}>
                        {item.render(fps, theme, aspectRatio, defaults, videoConfig)}
                    </React.Fragment>
                ))}
            </AbsoluteFill>
        );
    }
} 